module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hd-wap-recommend"
  }, [_c('div', {
    staticClass: "wp"
  }, [_c('div', {
    staticClass: "wp-inner"
  }, [_c('div', {
    staticClass: "page index"
  }, [_c('img', {
    staticClass: "logo js-animate animated",
    attrs: {
      "src": require("assets/images/recommend/icon_1.png"),
      "alt": "",
      "data-animate": "fadeInDown"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title f18 js-animate animated",
    attrs: {
      "data-animate": "fadeInDown"
    }
  }, [_vm._v("海渡职校")]), _vm._v(" "), _c('img', {
    staticClass: "info js-animate animated",
    attrs: {
      "src": require("assets/images/recommend/img_wenzi.png"),
      "alt": "",
      "data-animate": "fadeInDown"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button js-animate animated",
    attrs: {
      "href": "javascript:;",
      "data-animate": "fadeInLeft"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push("download")
      }
    }
  }, [_c('i', {
    staticClass: "icon iphone"
  }), _vm._v(" "), _c('span', {
    staticClass: "f14"
  }, [_vm._v("iPhone下载")])]), _vm._v(" "), _c('a', {
    staticClass: "button js-animate animated",
    attrs: {
      "href": "javascript:;",
      "data-animate": "fadeInLeft"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push("download")
      }
    }
  }, [_c('i', {
    staticClass: "icon android"
  }), _vm._v(" "), _c('span', {
    staticClass: "f14"
  }, [_vm._v("Android下载")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "page part"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "sliderContainer"
  }, [_c('slider', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "interval": 3000,
      "speed": 1000,
      "control-btn": false,
      "auto": true
    }
  }, [_c('slider-item', [_c('img', {
    staticStyle: {
      "width": "4.8rem",
      "margin-top": "1.467rem"
    },
    attrs: {
      "src": require("assets/images/recommend/icon_shuji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "f13"
  }, [_vm._v("专业的配套教材")]), _vm._v(" "), _c('p', [_vm._v("哈尔滨工业大学机器人领域专家教师及职业教育领域优秀教师潜心编纂。工业机器人技术专业\"十三五\"规划教材,工业机器人应用人才培养指定用书。")])]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticStyle: {
      "width": "4.8rem",
      "margin-top": "1.467rem"
    },
    attrs: {
      "src": require("assets/images/recommend/icon_live.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "f13"
  }, [_vm._v("丰富的视频教学洗印")]), _vm._v(" "), _c('p', [_vm._v("行业资深高级工程师现场录制,结合实物装备,针对知识点细化分解")])])], 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow",
    staticStyle: {
      "bottom": "0.133rem"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/recommend/icon-arrow-down.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "f18 js-animate animated",
    attrs: {
      "data-animate": "fadeInLeft"
    }
  }, [_vm._v("\n          专业工业机器人学习资源只在"), _c('span', {
    staticClass: "f18",
    staticStyle: {
      "color": "#24b2f9"
    }
  }, [_vm._v("海渡职校")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/recommend/icon-arrow-down-black.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page part",
    staticStyle: {
      "background": "#f4f8fb"
    }
  }, [_c('h1', {
    staticClass: "f18 js-animate animated",
    attrs: {
      "data-animate": "fadeInLeft"
    }
  }, [_vm._v("全网独一无二")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "js-animate animated",
    attrs: {
      "data-animate": "bounceIn"
    }
  }, [_vm._v("哈尔滨工业大学、哈工大机器人集团联合打造;免费优质课程、专注工业机器人教育;工业机器人学习从入门到精通")]), _vm._v(" "), _c('img', {
    staticClass: "js-animate animated",
    attrs: {
      "src": require("assets/images/recommend/img_duyiwuer.png"),
      "alt": "",
      "data-animate": "slideInRight"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/recommend/icon-arrow-down-black.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page part"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h1', {
    staticClass: "f18 js-animate animated",
    attrs: {
      "data-animate": "fadeInLeft"
    }
  }, [_vm._v("全新学习体验")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "js-animate animated",
    attrs: {
      "data-animate": "bounceIn"
    }
  }, [_vm._v("提供工业机器人领域轻量学习内容,每一块碎片时间都可以被更好地利用;除了轻量学习内容,还有更为丰富的进阶式学习系统,工业机器人学习,拾级而上;结合个性推荐、学习任务管理等多项功能、帮助你有效提升学习效果,成就机器人指挥官")]), _vm._v(" "), _c('img', {
    staticClass: "js-animate animated",
    attrs: {
      "src": require("assets/images/recommend/img_xuexitiyan.png"),
      "alt": "",
      "data-animate": "rollIn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/recommend/icon-arrow-down-black.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page part",
    staticStyle: {
      "background": "#f4f8fb"
    }
  }, [_c('h1', {
    staticClass: "f18 js-animate animated",
    attrs: {
      "data-animate": "fadeInLeft"
    }
  }, [_vm._v("签到送积分,自由兑换书籍和教学资源")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "js-animate animated",
    attrs: {
      "data-animate": "bounceIn"
    }
  }, [_vm._v("每天签到都有积分送,连续签到更有玫瑰和游轮邀请好友送400积分,8个好友加入就能免费的书籍")]), _vm._v(" "), _c('img', {
    staticClass: "js-animate animated",
    staticStyle: {
      "width": "7.253rem"
    },
    attrs: {
      "src": require("assets/images/recommend/img_qiandao.png"),
      "alt": "",
      "data-animate": "bounceInUp"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/recommend/icon-arrow-top-black.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2495ee34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recommend.vue
// module id = 317
// module chunks = 1